import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { b as makeGetIdentity, c as makePatchIdentity, d as makePostIdentity } from './payment-provisioning-actions.js';
import { I as IdentityService } from './business.service.js';
import { d as defineCustomElement$a } from './custom-popper2.js';
import { d as defineCustomElement$9 } from './form-control-date2.js';
import { d as defineCustomElement$8 } from './form-control-error-text2.js';
import { d as defineCustomElement$7 } from './form-control-number-masked2.js';
import { d as defineCustomElement$6 } from './form-control-select2.js';
import { d as defineCustomElement$5 } from './form-control-text2.js';
import { d as defineCustomElement$4 } from './form-control-tooltip2.js';
import { d as defineCustomElement$3 } from './identity-address-form.js';
import { d as defineCustomElement$2 } from './owner-form-core2.js';
import { d as defineCustomElement$1 } from './owner-form-inputs2.js';

const BusinessOwnerForm = /*@__PURE__*/ proxyCustomElement(class BusinessOwnerForm extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.errorEvent = createEvent(this, "error-event", 7);
        this.getOwner = undefined;
        this.patchOwner = undefined;
        this.postOwner = undefined;
        this.authToken = undefined;
        this.ownerId = undefined;
        this.businessId = undefined;
        this.allowOptionalFields = undefined;
        this.removeOwner = undefined;
        this.newFormOpen = undefined;
        this.ownersLength = undefined;
    }
    async validate() {
        return this.coreComponent.validate();
    }
    async submit() {
        return this.coreComponent.submit();
    }
    async validateAndSubmit({ onSuccess }) {
        this.coreComponent.validateAndSubmit({ onSuccess });
    }
    componentWillLoad() {
        this.initializeApi();
    }
    initializeApi() {
        if (!this.authToken) {
            return;
        }
        this.getOwner = makeGetIdentity({
            authToken: this.authToken,
            identityId: this.ownerId,
            service: new IdentityService()
        });
        this.patchOwner = makePatchIdentity({
            authToken: this.authToken,
            identityId: this.ownerId,
            service: new IdentityService()
        });
        this.postOwner = makePostIdentity({
            authToken: this.authToken,
            service: new IdentityService()
        });
    }
    render() {
        return (h("owner-form-core", { key: '332d1e77d01886f13aba09b32b2d5f2199131619', ownerId: this.ownerId, businessId: this.businessId, getOwner: this.getOwner, patchOwner: this.patchOwner, postOwner: this.postOwner, allowOptionalFields: this.allowOptionalFields, removeOwner: this.removeOwner, newFormOpen: this.newFormOpen, ownersLength: this.ownersLength, ref: ref => this.coreComponent = ref }));
    }
}, [0, "justifi-owner-form", {
        "authToken": [1, "auth-token"],
        "ownerId": [1, "owner-id"],
        "businessId": [1, "business-id"],
        "allowOptionalFields": [4, "allow-optional-fields"],
        "removeOwner": [16],
        "newFormOpen": [4, "new-form-open"],
        "ownersLength": [2, "owners-length"],
        "getOwner": [32],
        "patchOwner": [32],
        "postOwner": [32],
        "validate": [64],
        "submit": [64],
        "validateAndSubmit": [64]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-owner-form", "custom-popper", "form-control-date", "form-control-error-text", "form-control-number-masked", "form-control-select", "form-control-text", "form-control-tooltip", "justifi-identity-address-form", "owner-form-core", "owner-form-inputs"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-owner-form":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BusinessOwnerForm);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "form-control-date":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "form-control-number-masked":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "owner-form-core":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "owner-form-inputs":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BusinessOwnerForm as B, defineCustomElement as d };
